module.exports = __webpack_public_path__ + "media/images/smart_phone/sp_menu2-f3fc8dbc9bcf2035f96bb3ebb09a671c.png";